import React from "react";
import ExcalidrawViewer from "../../components/ExcalidrawViewer";

const AustraliaOilSources: React.FC = () => (
  <ExcalidrawViewer
    filePath="/excalidraw/australia-oil-import-sources.excalidraw"
    title="Where Australia Gets Its Petrol & Oil"
    subtitle="Import sources, remaining refineries, Strait of Hormuz dependency, and the fuel types at risk"
  />
);

export default AustraliaOilSources;
